export const previewTopCategories = {
  catalogGroupView: [
    { uniqueID: "preview-1", name: "Aligners" },
    { uniqueID: "preview-2", name: "Brackets" },
    { uniqueID: "preview-3", name: "Wires" },
    { uniqueID: "preview-4", name: "Bonding" },
    { uniqueID: "preview-5", name: "Instruments" },
  ],
};
